import * as React from "react";
import BaseUI, { IBaseUI } from "src/engine/ui/BaseUI";
import UIManifest from "src/engine/ui/UIManifest";
// import AntPagination from 'src/component/antd/AntPagination';
import IUIItem from "src/engine/interface/IUIItem";

interface IJDataPagination extends IBaseUI {
    pageSize?: number;
    pagination?: IUIItem[];
    dataFilterKey?: string;
    dataFilterUI?: IUIItem[];
    disabled?: boolean; //是否支持分页
    resetPagination?: boolean; //当data变化时，是否重置翻页
    dataArrKey?: string;
}
interface IState {
    current: number;
    pageSize: number;
    filter?: string;
    paginationKey?: string; //是否需要重新渲染翻页组件
}

@UIManifest.declareGG(["ggValue"], "JDataPagination", "JDataPagination组件", UIManifest.Type.JJ)
class JDataPagination extends BaseUI<IJDataPagination, IState> {
    constructor(props: IJDataPagination) {
        super(props);
        this.state = {
            current: 1,
            pageSize: Number(this.props.pageSize || 10),
            paginationKey: '1'
        };
    }

    componentDidUpdate = (prevProps: any) => {
        const { data = [], resetPagination = false } = this.props;
        // 当data内容变化时，将当前页置为1；
        if (resetPagination && !this.arrayEquals(prevProps.data, data)) {
            this.setState({ current: 1, paginationKey: new Date().toLocaleTimeString() });
        }
    }

    arrayEquals = (prevArr: any[], currArr: any[]) => {
        const { dataArrKey = "" } = this.props;
        if (prevArr.length !== currArr.length) return false;
        if (dataArrKey?.length > 0) {
            for (const i in prevArr) {
                if (prevArr[i][dataArrKey] !== currArr[i][dataArrKey]) {
                    return false;
                }
            }
        }
        return true;
    }

    onShowSizeChange = (cur: number, pageSize: number) => {
        const state: any = { pageSize };
        const { data = [] } = this.props;
        if (data.length > 0 && data.length / pageSize < this.state.current) {
            state.current = 1;
        }
        this.setState(state);
    };

    onChange = (current: number) => {
        this.setState({ current });
    };

    filterData(data: any[], filter: string, dataFilterKey: string = "---") {
        const ret: any[] = [];
        data.forEach((item) => {
            item = { ...item };
            //判断是否包含
            if (item[dataFilterKey].indexOf(filter) >= 0) {
                ret.push(item);
            } else {
                //过滤子元素
                if (item.children) {
                    item.children = this.filterData(item.children, filter, dataFilterKey);
                    if (item.children.length > 0) {
                        ret.push(item);
                    }
                }
            }
        });
        return ret;
    }

    getData(data: any[] = []) {
        const { current, pageSize, filter } = this.state;
        if (filter && filter !== "全部") {
            // data = data.filter?.((item) => {
            //     return item[this.props.dataFilterKey || "---"].indexOf(filter) >= 0;
            // });
            data = this.filterData(data, filter, this.props.dataFilterKey);
        }
        console.log("dataPagination", current, pageSize, filter, data)
        return this.props.disabled ? data : data?.slice?.((current - 1) * pageSize, current * pageSize) || [];
    }

    onFilterChange = (filter: string) => {
        // console.log("[JDataPagination]", "filter", filter);
        this.setState({ filter });
    };

    renderFilter() {
        const { dataFilterUI = [], dataFilterKey, data = [] } = this.props;
        if (dataFilterUI.length === 0 || !dataFilterKey) return null;
        const caches: any = {};
        let ret = data?.filter((item: any) => {
            const ret = typeof item[dataFilterKey] !== "undefined";
            //避免添加同一个值，重复的问题
            if (ret && !caches[item[dataFilterKey]]) {
                caches[item[dataFilterKey]] = true;
                return true;
            }
            return false;
        });
        ret = [{ [dataFilterKey]: "全部" }, ...ret];
        return this.renderChildren(dataFilterUI, { data: ret, onChange: this.onFilterChange });
    }

    render() {
        const { data = [], pagination = [], children } = this.props;
        return (
            <div className="react-data-page" style={this.getStyle()}>
                {this.renderFilter()}
                {this.renderChildren(children, { data: this.getData(data) })}
                {this.renderChildren(pagination, { ...this.state, key: this.state.paginationKey, total: data.length, onShowSizeChange: this.onShowSizeChange, onChange: this.onChange })}
                {/* <AntPagination {...other} {...this.state} total={data.length} onShowSizeChange={this.onShowSizeChange} onChange={this.onChange} /> */}
            </div>
        );
    }
}

export default JDataPagination;
